module.exports = __webpack_public_path__ + "img/loading-2.1b4ccfbd.gif";